module.exports = __webpack_public_path__ + "img/ethiopians-DE.fe969fbe.png";